import { render } from "./LogoForApp.vue?vue&type=template&id=9952d48c&scoped=true&ts=true"
import script from "./LogoForApp.vue?vue&type=script&lang=ts"
export * from "./LogoForApp.vue?vue&type=script&lang=ts"

import "./LogoForApp.vue?vue&type=style&index=0&id=9952d48c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9952d48c"]])

export default __exports__